import Decorator from 'lf/decorators/Decorator';

import FeedbackButtonDecorator from '../../lernfragen/FeedbackButtonDecorator';
import FeedbackAndReviewButtonsDecorator from '../../lernfragen/FeedbackAndReviewButtonsDecorator';
import Quiz from '../quiz/Quiz';

/**
 * Specialization of `Quiz` that has an additional 'review' button next to the 'feedback' button.
 */
export default class LernVideoQuiz extends Quiz {

    public constructor( model:any, private readonly canReview:() => boolean, private readonly review:() => void ) {
        super(model);
    }

    addFeedbackDecorator() {
        let decorator:Decorator;
        if( this.canReview() ) {
            const feedbackAndReviewDecorator = new FeedbackAndReviewButtonsDecorator();
            feedbackAndReviewDecorator.review.add( this.review, this );
            decorator = feedbackAndReviewDecorator;
        }
        else {
            decorator = new FeedbackButtonDecorator();
        }
        this.lernfragen.renderer.slideChanged.add( decorator.decorate.bind( decorator ) );
    }
}
